import i18n from 'i18next';

import { store } from '@store';
import { AuthenticationStatus } from '@store/types';
import { setLocale as setLocaleRequest } from '@services/user';

import { setLanguageLocalStorage } from '@utils';

export const setLanguage = (lng: string, skipApi?: boolean) => {
  if (lng === i18n.language) {
    return;
  }

  setLanguageLocalStorage(lng);

  if (
    skipApi ||
    store.getState().authentication.status !==
      AuthenticationStatus.authenticated
  ) {
    document.location.reload();
    return;
  }

  setLocaleRequest({ locale: lng }).then(() => document.location.reload());
};
